<template>
  <div class="layout-center-wrap">
    <div class="page-tit__wrap">
      <h1 class="page-tit__sub">취약점 정보</h1>
      <h2 class="page-tit">공개된 취약점</h2>
    </div>
    <article class="board-view">
      <header class="detail-view__head">
        <p class="detail-view__tit" v-if="selectedTab === 0">
          {{ item.title }}
        </p>
        <p class="detail-view__tit" v-else>{{ item.title_en }}</p>
        <div
          class="detail-view__info__wrap"
          :aria-label="changeLang('aria.postInfo')"
        >
          <p class="detail-view__info">
            작성일 : {{ convertDateFormatFromId(item.id) }}
          </p>
          <p class="detail-view__info">조회수 : {{ item.view_cnt }}</p>
        </div>
      </header>

      <div
        class="detail-view__body pd0"
        v-if="selectedTab === 0"
        v-dompurify-html="item.content_html"
      ></div>
      <div
        class="detail-view__body pd0"
        v-else
        v-dompurify-html="item.content_html_en"
      ></div>
      <div class="detail-view__nav">
        <a
          v-if="prevItem"
          @click.prevent="goToItem(prevItem.id)"
          class="detail-view__nav__link detail-view__nav__link--prev"
          :aria-label="changeLang('aria.prevPost')"
        >
          <p class="detail-view__nav-label" aria-hidden="true">
            <i class="svg_icon icon_arrow_down"></i>{{ changeLang("prevPost") }}
          </p>
          <p class="detail-view__nav-ti">{{ prevItem.title }}</p>
        </a>
        <a
          v-if="nextItem"
          class="detail-view__nav__link"
          :aria-label="changeLang('aria.nextPost')"
          @click.prevent="goToItem(nextItem.id)"
        >
          <p class="detail-view__nav-label" aria-hidden="true">
            <i class="svg_icon icon_arrow_down"></i>{{ changeLang("nextPost") }}
          </p>
          <p class="detail-view__nav-tit">{{ nextItem.title }}</p>
        </a>
      </div>
    </article>
    <div class="btn__wrap type-bottom-board">
      <router-link :to="getListRoute()" class="btn btn--m btn--blue">{{
        changeLang("list")
      }}</router-link>
    </div>
  </div>
</template>

<script>
import { useRoute, useRouter } from "vue-router";
import { inject, onMounted, ref, computed } from "vue";
import { useStore } from "vuex";
import dt from "@/component/utils/DateTime.js";
import dc from "@/component/utils/DataChk.js";

export default {
  setup() {
    const route = useRoute();
    const router = useRouter();
    const axios = inject("axios");
    const store = useStore();
    const showLoading = () => store.dispatch("loading/show");
    const hideLoading = () => store.dispatch("loading/hide");

    // data 정의
    const item = ref({ title: "", id: "", content_html: "", view_cnt: "" });
    const prevItem = ref(item.value); // 이전글 데이터
    const nextItem = ref(item.value); // 다음글 데이터
    const searchInfo = ref({ collectionType: "DOMESTICVULINFO" });
    const id = route.query.id ? route.query.id : null;
    const selectedTab = ref(0);

    // methods 정의
    const fetchNoticeDetail = async (id) => {
      searchInfo.value.id = id;
      showLoading();
      axios
        .post("/core/pu/view/vuln-public/detail/get", searchInfo.value)
        .then((res) => {
          if (res.data.resType === "RES_OK") {
            const indices =
              res.data.resList.length === 3 ? [0, 1, 2] : [1, 0, null];
            let [pre, current, next] = indices;
            item.value = res.data.resList[current];
            prevItem.value = res.data.resList[pre];
            nextItem.value = next ? res.data.resList[next] : null;
          } else {
            alert(res.data.resMsg);
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          hideLoading();
        });
    };

    const convertDateFormatFromId = (objectId) => {
      return dt.dateFromObjectId(objectId);
    };

    const goToItem = async (id) => {
      // 1. 새로운 ID로 게시물 상세 정보 다시 불러오기
      await fetchNoticeDetail(id);

      // 2. 브라우저 히스토리를 추가하지 않고 URL만 변경
      router.replace({ query: { id } });
    };

    const getListRoute = () => {
      return {
        path: "/info/vuln/public",
        query: { tab: route.query.tab },
      };
    };

    //computed 정의
    const changeLang = computed(() => {
      const isKorean = selectedTab.value === 0;
      return (key) => {
        const translations = {
          aria: {
            postInfo: isKorean ? "게시물 정보" : "Post info",
            prevPost: isKorean ? "이전글" : "Previous post",
            nextPost: isKorean ? "다음글" : "Next post",
          },
          prevPost: isKorean ? "이전글" : "Prev",
          nextPost: isKorean ? "다음글" : "Next",
          list: isKorean ? "목록" : "List",
        };
        // 키 경로를 점으로 분리하여 객체 탐색
        const keys = key.split(".");
        return keys.reduce(
          (obj, k) => (obj && obj[k] !== "undefined" ? obj[k] : key),
          translations
        );
      };
    });
    // life cycle 정의
    onMounted(() => {
      selectedTab.value =
        JSON.parse(sessionStorage.getItem("vulnPublicSelectedTab")) || 0;
      const data = sessionStorage.getItem("vulnPublicSearchInfo");
      if (data) {
        searchInfo.value = JSON.parse(data);
      }
      if (!id) {
        router.push("/");
        return;
      }
      fetchNoticeDetail(id);
    });
    // html에서 사용될 데이터 정의
    return {
      item,
      prevItem,
      nextItem,
      convertDateFormatFromId,
      goToItem,
      getListRoute,
      selectedTab,
      changeLang,
      route,
    };
  },
};
</script>